// extracted by mini-css-extract-plugin
export var link = "_sf-0";